/** @format */
import { Injectable } from '@angular/core';
import { ModalService } from 'sis-common';
import { FileUploadInfoModalComponent, FileUploadInfoModalValues } from './file-upload-info-modal.component';

@Injectable({
    providedIn: 'root',
})
export class FileUploadInfoModalService {
    constructor(private modalService: ModalService) {}

    confirm(values: FileUploadInfoModalValues): Promise<any> {
        return this.modalService.open(FileUploadInfoModalComponent, values, { windowClass: 'file-upload-info-modal', size: 'sm' }).result;
    }
}
